import { PropsWithChildren } from 'react';
import './Page.scss';

export default function Page(props: PropsWithChildren) {
  const { children } = props;

  return (
    <>
      <div className="page contained">
        <div className="body">{children}</div>
      </div>
    </>
  );
}
